const sourceLabels: Record<string, string> = {
  '1C': '1С',
  'master-shina': 'МастерШина',
  dikarshina: 'Dikarshina',
  yst: 'Терминал YST',
};

export const getWheelSourceLabel = (source?: string | null): string => {
  const value = source?.trim();
  if (!value) return 'Не указан';
  return Object.prototype.hasOwnProperty.call(sourceLabels, value) ? sourceLabels[value] : value;
};
